import { Guide } from '@zenterprise-inc/ui';

const ErrorDuplicateApplyContent = () => {
  return (
    <div className="flex h-[calc(100vh-100px)] w-full flex-col items-center justify-center ">
      <Guide>
        <Guide.TextArea>
          <Guide.Title>이미 환급 신청을 완료하셨네요!</Guide.Title>
          <Guide.Description>
            결과는 신청했던 계정으로만 확인할 수 있어요.
            <br />
            아래 이메일로 로그인해주세요.
          </Guide.Description>
        </Guide.TextArea>
      </Guide>
      <div className="rounded-2.5 inline-flex items-center justify-center bg-gray-100 p-3 text-gray-800">fl****************@naver.com</div>
    </div>
  );
};

export default ErrorDuplicateApplyContent;
